import { isExpired } from "react-jwt";
import Cookies from 'js-cookie';
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import configData from "../config/config.json";

export const TokenVerificationLoggedin = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;
    if(!status){
        window.location.replace("/login")
    }

    if(status){
    let token= Cookies.get("token_xapads_ssp")
    const isMyTokenExpired = isExpired(token);
    if(isMyTokenExpired){
        Cookies.remove("token_xapads_ssp")
        window.location.replace("/login")
      }
    }
  }

  export const TokenVerificationLoggedOut = () => {
      let status= Cookies.get("token_xapads_ssp")?true:false;      
       if (status) {
        let token= Cookies.get("token_xapads_ssp")
        let id = jwtDecode(token)._id;
        let role =jwtDecode(token).role

          if (role === "sa" ||role === "mobops") {
            window.location.replace("/dashboard");
          }

          if(role==='admin'){
            axios
            .get(configData.SERVER_URL + "user/status?_id="+id)
            .then((response) => {
           
             if(response.data.data.status==="verified"){
              window.location.replace("/onboarding")
             } 
             else {
              window.location.replace("/dashboard")
             }
          
            })
     
          }
      } 
  }


  export const ScreenView = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;      
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if(role==='admin'){
    axios
    .get(configData.SERVER_URL + "user/status?_id="+id)
    .then((response) => {
      if(response.data.data.status==="verified"){
      window.location.replace("/onboarding")
     }
   
  })
  .catch((error) => {});
  }
    }
  }

  export const ScreenViewOnboarding = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;      
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if(role==='admin'){
    axios
    .get(configData.SERVER_URL + "user/status?_id="+id)
    .then((response) => {
      if(response.data.data.status==="approved"){
      window.location.replace("/dashboard")
     }
  })
  .catch((error) => {});
  }
 
    }
  
  }

  export const BlockAdmin = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;      
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if(role==='admin'){

      axios
      .get(configData.SERVER_URL + "user/status?_id="+id)
      .then((response) => {
        if(response.data.data.status==="approved"){
        window.location.replace("/dashboard")
       }
       if(response.data.data.status==="verified"){
        window.location.replace("/onboarding")
       }
    })
    .catch((error) => {});
    }
    }
  
  }

  export const BlockOtherThanAdmin = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;      
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if(role!=='admin'){
      window.location.replace("/dashboard")
     }
 
    }
  
  }

  export const BlockOtherThanSA = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;      
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if(role!=='sa'){
      window.location.replace("/dashboard")
     }
 
    }
  
  }

  


  




